import axios2 from '../api/axios';
export const saleServices = {
    createsale,
    editsale,
    getsaledata,
    deletesale,
    getLastOrderId,
    salesReport,
    updateStatus,
    updateReturnedStock,
    getOrderTrackingData,
    getproductTracking,
    ordergraphs,
    updatePaymentStatus,
    getWareHouseLocation,
    getAvailableStock,
    updateallocationdata
    // getShopifyData
    // getDepartment,
    // createdesignation,
    // getDesignations    
}

function createsale(objdata){
    return axios2.post(`/createsale`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
       // console.log(error); 
       throw error;
   })   
}

function editsale(objdata){
    return axios2.post(`/editsale`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
       throw error;
   })   
}

function getsaledata(page, pageSize,status){
    return axios2.get(`/getsaledata?page=${page}&pageSize=${pageSize}&status=${status}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}



function deletesale(id){
        return axios2.post(`/deletesale`,id,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })  
}
function getLastOrderId() {
    return axios2.get('/getLastOrderId', ((response) => {
        return response;
    })).catch((error) => {
        console.log(error);
    });
}
function salesReport({status='all',page='1',limit=25}){
     return axios2.get(`/salesReport?status=${status}&page=${page}&limit=${limit}`, ((response) => {
        return response;
    })).catch((error) => {
        console.log(error);
    }); 
}

function updateStatus(obj){
    return axios2.post(`/updateSaleStatus`, obj,((response) => {
        return response;
    })).catch((error) => {
        console.log(error);
    })
}

function updateReturnedStock(obj){
    return axios2.post('/updateReturnStock', obj, ((response) => {
        return response;
    })).catch((error) => {
        console.log(error);
    })
}

function getOrderTrackingData(order_id){
    return axios2.post('/orderTrackingStock', order_id, ((response) => {
        return response;
    })).catch((error) => {
        console.log(error);
    })
}

function getproductTracking(){
    return axios2.get('/getproductTracking', ((response) => {
        return response;
    })).catch((error) => {
        console.log(error);
    }) 
}

function ordergraphs(){
    return axios2.get('/ordergraphs', ((response) => {
        return response;
    })).catch((error) => {
        console.log(error);
    })   
}

function updatePaymentStatus(obj){
    return axios2.post(`/updatePaymentStatus`, obj,((response) => {
        return response;
    })).catch((error) => {
        console.log(error);
    })
}

function getWareHouseLocation(order_id){
    let obj = { order_id: order_id };
    return axios2.post('/getwarehousesviastock', obj, ((response) => {
        return response;
    })).catch((error) => {
        console.log(error);
    })  
}   

function getAvailableStock({order_id,product_id,warehouse_code}) {
    return axios2.get(`/getAvailableStock?order_id=${order_id}&&product_id=${product_id}&&warehouse_code=${warehouse_code}`, ((response) => {
        return response;
    })).catch((error) => {
        console.log(error);
    });
}


function updateallocationdata({previous_allocation,new_allocation}) {
    let obj = { previous_allocation: previous_allocation, new_allocation: new_allocation };
    return axios2.post('/updateallocationdata',obj, ((response) => {
        return response;
    })).catch((error) => {
        console.log(error);
    });
}

// function getShopifyData(){
//     return axios2.post('/shopify_order', ((response) => {
//         return response;
//     })).catch((error) => {
//         console.log(error);
//     });
// }